module.exports = __webpack_public_path__ + "static/Thumbnail_Video-072e68d6de496306a7d060388384c97d.png";